import SVGProps from 'src/components/icons/config/svg-props' //
// Auto-generated file created by svgr-cli source svg-template.cjs
// Run npm run generate-icons to update
// Do not edit
const SvgCookieIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill="none"
    viewBox="0 0 64 64"
    role="img"
    className="icon"
    {...props}
  >
    <mask
      id="cookie-icon_svg__a"
      width={31}
      height={30}
      x={17.372}
      y={15.233}
      fill="#000"
      maskUnits="userSpaceOnUse"
    >
      <path fill="#fff" d="M17.372 15.233h31v30h-31z" />
      <path
        fillRule="evenodd"
        d="M37.547 26.017a6.036 6.036 0 0 1-6.665-7.784c-5.943.857-10.51 5.971-10.51 12.152 0 6.782 5.498 12.28 12.28 12.28 5.937 0 10.89-4.216 12.031-9.817a6.036 6.036 0 0 1-7.136-6.83"
        clipRule="evenodd"
      />
    </mask>
    <path
      fill="currentColor"
      d="m37.547 26.017 2.176.328.444-2.947-2.948.444zm-6.664-7.784 2.098.661 1.052-3.338-3.464.5zm13.8 14.615 2.156.439.658-3.233-3.237.635zm-7.464-9.006a4 4 0 0 1-.579.043v4.4q.629-.001 1.235-.092zm-.579.043a3.836 3.836 0 0 1-3.835-3.836h-4.4a8.236 8.236 0 0 0 8.235 8.236zm-3.835-3.836c0-.406.062-.793.176-1.155l-4.197-1.323a8.2 8.2 0 0 0-.38 2.478zm-2.236-3.994c-7.011 1.011-12.397 7.04-12.397 14.33h4.4c0-5.071 3.748-9.272 8.625-9.975zm-12.397 14.33c0 7.997 6.483 14.48 14.48 14.48v-4.4c-5.567 0-10.08-4.513-10.08-10.08zm14.48 14.48c7.004 0 12.842-4.973 14.187-11.578l-4.312-.878c-.935 4.597-5.004 8.055-9.876 8.055zM44.26 30.688q-.36.071-.745.072v4.4a8.3 8.3 0 0 0 1.591-.154zm-.745.072a3.836 3.836 0 0 1-3.835-3.836h-4.4a8.236 8.236 0 0 0 8.235 8.236zm-3.835-3.836q0-.298.043-.58l-4.351-.656a8 8 0 0 0-.092 1.236z"
      mask="url(#cookie-icon_svg__a)"
    />
    <ellipse
      cx={26.511}
      cy={26.292}
      fill="currentColor"
      rx={2.046}
      ry={2.047}
    />
    <ellipse
      cx={34.698}
      cy={36.525}
      fill="currentColor"
      rx={2.046}
      ry={2.047}
    />
    <circle cx={31.116} cy={24.757} r={0.512} fill="currentColor" />
    <circle cx={25.488} cy={35.502} r={1.023} fill="currentColor" />
    <circle cx={31.628} cy={31.409} r={1.023} fill="currentColor" />
    <circle cx={39.814} cy={33.455} r={1.023} fill="currentColor" />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.605 35.57a1.1 1.1 0 0 0 .048-1.555l-3.923-4.171-1.255-.211a1.1 1.1 0 0 0-1-.168l-1.502-.253-4.703 4.423a1.1 1.1 0 0 0 1.507 1.603l3.96-3.724c.523 11.445 9.968 20.563 21.541 20.563a1.1 1.1 0 1 0 0-2.2c-10.102 0-18.397-7.736-19.286-17.606l3.058 3.251a1.1 1.1 0 0 0 1.555.048M46.974 24.43a1.1 1.1 0 0 0-.048 1.555l3.923 4.171 1.255.211a1.1 1.1 0 0 0 1 .168l1.502.253 4.703-4.423a1.1 1.1 0 1 0-1.507-1.603l-3.96 3.724C53.32 17.04 43.876 7.923 32.302 7.923a1.1 1.1 0 0 0 0 2.2c10.102 0 18.397 7.736 19.286 17.606l-3.058-3.251a1.1 1.1 0 0 0-1.555-.048"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgCookieIcon
